import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  billingRequest: ['props'],
  billingSuccess: ['data'],
  billingFailure: ['error'],

  billingDownloadRequest: ['props'],
  billingDownloadSuccess: ['data'],
  billingDownloadFailure: ['error'],
});

export const BillingTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  totalPages: 0,
  error: null,
  fetching: false,

  downloadFetching: false,
  downloadError: null,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge({fetching: true});

// we've successfully ...
export const success = (state, {data}) =>
  state.merge({
    fetching: false,
    error: null,
    data: data ? data.page && data.page > 1 ? [...state.data, ...data.data] : data.data : null,
    totalPages: data && data.totalPages ? data.totalPages : 0,
  });

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});

export const downloadRequest = state => 
  state.merge({
    downloadFetching: true,
    downloadError: null,
  });

  
export const downloadSuccess = state =>
  state.merge({
    downloadFetching: false,
    downloadError: null,
  });

export const downloadFailure = (state, {error}) =>
  state.merge({
    downloadFetching: false,
    downloadError: error,
  });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.BILLING_REQUEST]: request,
  [Types.BILLING_SUCCESS]: success,
  [Types.BILLING_FAILURE]: failure,

  [Types.BILLING_DOWNLOAD_REQUEST]: downloadRequest,
  [Types.BILLING_DOWNLOAD_SUCCESS]: downloadSuccess,
  [Types.BILLING_DOWNLOAD_FAILURE]: downloadFailure,
});
